import logInternalLinkClick from "lib/ga/internalLinkClick";
import Link from "next/link";
import AreaContainer from "../AreaContainer";
import styles from './sponsored.module.css'
import globalStyles from '../result.module.css';

interface Props {
    id: number;
    dark: string;
    name: string;
    url: string;
    logo_uri: string;
    resultId: number;
} 

const SponsoredBanner = ({ id, dark, name, url, logo_uri, resultId }: Props) => {
    return (
        <AreaContainer area="sponsored" style={null} extraClass={null}>
            <div className={`${styles.Banner}`} style={{ backgroundColor: dark || 'transparent' }}>
                <div className={`${styles.bannerContent} ${globalStyles.pageContainer}`}>
                    <Link href={url} prefetch={false} passHref>
                        <div className={styles.CompanyWrapper} onClick={(e) => logInternalLinkClick("Scheme Sponsored Banner", url, resultId)}>

                            <div className={styles.CompanyWrapperInner}>
                                <div className={styles.logo} style={{ backgroundImage: `url(${logo_uri})` }} />
                                <div>
                                    <p className={styles.smallHeading}>Part of a retail</p>
                                    <h1 className={styles.largeText}>Portfolio | {name}</h1>
                                </div>
                            </div>

                            <div>
                                <button className={styles.smallButton}>View Portfolio</button>
                            </div>

                        </div>
                    </Link>
                </div>
            </div>
        </AreaContainer>
    )
}

export default SponsoredBanner;